import React from "react";
import { useInfiniteQuery } from "react-query";
import { fetchProperties } from "../api";
import Grid from "../components/Grid/Grid";
import LoadingButton from "../components/LoadingButton/LoadingButton";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OpenMap from "../components/OpenMap/OpenMap";

import Table from "../components/Table/Table";
import formatNumber from "../helpers/formatNumber";
import {
  faMoneyBillTrendUp,
  faHandHoldingDollar,
  faHouse,
  faTree,
  faSeedling,
  faBuildingUser,
  faMoneyBillTransfer,
  faBuildingColumns,
} from "@fortawesome/free-solid-svg-icons";

const specialIconCategories = {
  EFH: faHouse,
  farm: faSeedling,
  forest: faTree,
  apartment: faBuildingUser,
};

const columns = [
  {
    label: "",
    field: "nft",
    colWidth: "75%",
    rowValue: (_, row) => (
      <Link
        to={`/portfolio/property/${row?.zip}/${row?.propertyId}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dividend-payment-container">
          <div className="dividend-payment-image-container">
            <FontAwesomeIcon
              className="text-light"
              size="lg"
              height={45}
              width={45}
              style={{ marginRight: 8, marginTop: 10 }}
              icon={specialIconCategories?.[row.type]}
            />
          </div>
          <div
            className="dividend-payment-text-container"
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div className="dividend-payment-date text-muted">
              <span className="trades-share-badge badge badge-info">
                {row?.address?.city}
              </span>
            </div>
            <div className="dividend-payment-name text-light">
              {`${row?.address?.street} ${row?.address?.house_number}`}
            </div>
          </div>
        </div>
      </Link>
    ),
  },
  {
    label: "",
    field: "totalInvestment",
    colWidth: "25%",
    rowValue: (val, row) => {
      const currentValue = row?.propertyValue || 0;
      return (
        <div className="d-flex align-items-center p-3 justify-content-end">
          <span className="dividend-payment-value  badge badge-success">
            + {formatNumber(currentValue)} €
          </span>
        </div>
      );
    },
  },
];

function Property({ title }) {
  const { currentUser } = useAuth;
  const limit = 25;

  //* load trades by limit
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      ["myproperties"],
      async ({ pageParam = 0 }) => {
        return fetchProperties(pageParam, limit);
      },
      {
        getNextPageParam: (lastPage, allPages) => {
          // Wenn weniger als limit Elemente kamen, ist Schluss
          if (lastPage.length < limit) return undefined;
          return allPages.length; // nächste page
        },
        // 👇 Deine zusätzlichen Optionen
        staleTime: 1000 * 60 * 5, // 5 Minuten Frischezeit
        cacheTime: 1000 * 60 * 10, // 10 Minuten im Cache
        refetchOnWindowFocus: false, // Kein Refetch bei Fokus
        refetchOnMount: false, // Kein Refetch beim Mount
        enabled: currentUser?.authenticated,
      },
    );

  const allItems = data?.pages.flat() || [];

  return (
    <>
      <h1 className="text-light text-center">{title}</h1>
      <p className="text-muted text-center">
        Deine Immobilien und Grundstücke auf einen Blick
      </p>

      <div>
        <Grid>
          <div className="col-6 col-lg-3 text-center portfolio-dashboard-grid">
            <div className="rounded portfolio-dashboard-keyfacts">
              <FontAwesomeIcon
                icon={faMoneyBillTrendUp}
                className="text-muted"
              />
              <p className="stockinfo-keyfacts-value text-lawngreen">
                {`${formatNumber(allItems?.[0]?.totalPropertyValue?.toFixed(2))}`}
              </p>
              <p className="portfolio-keyfacts-label text-muted">
                Gesamtwert €
              </p>
            </div>
          </div>

          <div className="col-6 col-lg-3 text-center portfolio-dashboard-grid">
            <div className="rounded portfolio-dashboard-keyfacts">
              <FontAwesomeIcon
                icon={faBuildingColumns}
                className="text-muted"
              />
              <p
                className="stockinfo-keyfacts-value"
                style={{ color: "tomato" }}
              >
                {`${formatNumber(allItems?.[0]?.totalDebtAmountOpen?.toFixed(2))}`}
              </p>
              <p className="portfolio-keyfacts-label text-muted">Schulden €</p>
            </div>
          </div>

          <div className="col-6 col-lg-3 text-center portfolio-dashboard-grid">
            <div className="rounded portfolio-dashboard-keyfacts">
              <FontAwesomeIcon
                icon={faMoneyBillTransfer}
                className="text-muted"
              />
              <p
                className="stockinfo-keyfacts-value"
                style={{ color: "tomato" }}
              >
                {`${formatNumber(allItems?.[0]?.monthlyCosts?.toFixed(2))}`}
              </p>
              <p className="portfolio-keyfacts-label text-muted">
                Ausgaben mtl.
              </p>
            </div>
          </div>

          <div className="col-6 col-lg-3 text-center portfolio-dashboard-grid">
            <div className="rounded portfolio-dashboard-keyfacts">
              <FontAwesomeIcon
                icon={faHandHoldingDollar}
                className="text-muted"
              />
              <p className="stockinfo-keyfacts-value text-lawngreen">
                {`${formatNumber((0).toFixed(2))}`}
              </p>
              <p className="portfolio-keyfacts-label text-muted">
                Einnahmen mtl.
              </p>
            </div>
          </div>
        </Grid>
      </div>
      <br />

      <div className="article-main">
        <Grid>
          <h5
            className="text-light text-left col-12"
            style={{ marginTop: "-10px" }}
          >
            Immobilien{" "}
            <span className="dividend-payment-subtitle text-muted">
              ({allItems?.[0]?.total})
            </span>
            {/* <button
              className="btn btn-link dismiss-active-or-focus delete-form-label"
              data-toggle="modal"
              data-target="#addTrade"
              onClick={(e) => {
                e.preventDefault();
                setShowNftModal((prev) => !prev);
              }}
            >
              <FontAwesomeIcon icon={faSquarePlus} />
            </button> */}
          </h5>
          <Table data={allItems} columns={columns} id="test" />
          {hasNextPage && (
            <div className="text-center mt-6">
              <LoadingButton
                onClick={() => fetchNextPage()}
                loading={isFetchingNextPage}
              />
            </div>
          )}
          {allItems?.[0]?.propertyCoordinates && (
            <>
              <h5 className="text-muted">Kartenansicht</h5>
              <OpenMap locations={allItems?.[0]?.propertyCoordinates} />
            </>
          )}
        </Grid>
      </div>

      {/* <Modal
        id="addTrade"
        visible={showNftModal}
        setVisible={setShowNftModal}
        title="NFT hinzufügen"
        onSave={(formData) => {
          if (
            formData?.chain &&
            formData?.contract &&
            formData?.id &&
            formData?.date
          ) {
            addNewNFT(
              formData?.chain,
              formData?.contract,
              formData?.id,
              formData?.date,
            )
              .then((result) => {
                createNotification("success", result.message);
                queryClient.invalidateQueries(["mynft"]);
              })
              .catch((err) => {
                createNotification("error", err.message);
              });
          } else {
            createNotification("error", "Bitte alle Daten angeben");
          }
        }}
      >
        <div className="form-group col-12">
          <label className="text-dark" for="chain">
            Blockchain
          </label>
          <div className="input-group">
            <select
              className="form-control"
              id="chain"
              name="chain"
              data-live-search="true"
              showContent="true"
            >
              {listOfSupportedChains?.map((row) => (
                <option key={row?.value} value={row?.value}>
                  {row?.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-group col-12">
          <label className="text-dark" for="contract">
            Smartcontract
          </label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id="contract"
              name="contract"
            />
          </div>
        </div>

        <div className="form-group col-12">
          <label className="text-dark" for="id">
            Token ID
          </label>
          <div className="input-group">
            <input type="text" className="form-control" id="id" name="id" />
          </div>
        </div>

        <div className="form-group col-12">
          <label className="text-dark" for="date">
            Datum
          </label>
          <div className="input-group">
            <input type="date" className="form-control" id="date" name="date" />
          </div>
        </div>
      </Modal> */}
    </>
  );
}

export default Property;
